import { match } from 'ts-pattern'

import { type SurveyGroupFilterItem } from './surveyGroupFilterGroups'

type ExtractByCategory<Category extends SurveyGroupFilterItem['category']> =
  Extract<
    SurveyGroupFilterItem,
    {
      category: Category
    }
  >

type MatchFilterMethods<T> = {
  question: (question: ExtractByCategory<'Question'>['question']) => T
  customerAttribute: (
    customerAttribute: ExtractByCategory<'CustomerAttribute'>['customerAttribute'],
  ) => T
  brandSegments: (
    brandSegments: ExtractByCategory<'BrandSegments'>['brandSegments'],
  ) => T
}

/**
 * カテゴリーごとに処理を分岐します。
 *
 * @param filter - フィルター。
 * @param methods - カテゴリーごとの処理。
 * @returns カテゴリーごとの処理の結果。
 */
export function matchSurveyGroupFilter<T>(
  filter: SurveyGroupFilterItem,
  methods: MatchFilterMethods<T>,
) {
  return match(filter)
    .with({ category: 'Question' }, ({ question }) =>
      methods.question(question),
    )
    .with({ category: 'CustomerAttribute' }, ({ customerAttribute }) =>
      methods.customerAttribute(customerAttribute),
    )
    .with({ category: 'BrandSegments' }, ({ brandSegments }) =>
      methods.brandSegments(brandSegments),
    )
    .exhaustive()
}
